import fetch from '@/api/fetch'

/** 查询用户列表 */
export const getUserList = params => fetch.post('/sys/user/query', params);

/** 根据id查询用户 */
export const getUserById = id => fetch.get(`/sys/user/id/${id}`);

/** 根据用户id查询工资 */
export const getWageByUserId = userId => fetch.get(`/sys/user/wage/user_id/${userId}`);

/** 根据用户id查询项目 */
export const getProjectUserByUserId = userId => fetch.get(`/sys/user/pro/user_id/${userId}`)

/** 获取项目人员工作状态纪录 */
export const getProUserWorkStatusRecordList = proUserId => fetch.get(`/sys/user/pro/detail/id/${proUserId}`)

/** 根据用户id查询登陆日志 */
export const getUserLoginLogByUserId = params => fetch.get(`/sys/user/login/log`, { params });

/** 根据用户id修改用户信息 */
export const updateBankNO = user => fetch.post(`/sys/user/updateBankNO`, user);